import React from 'react';
import { SearchFieldWithDebounce } from '@adjust/dashboard-components';

interface SearchListOwnProps {
  name: string;
  value: string;
  placeholder: string;
}

interface SearchListDispatchProps {
  onSearch: (searchTerm?: string) => void;
}

type SearchListProps = SearchListOwnProps & SearchListDispatchProps;

export const SearchListComponent: React.FC<SearchListProps> = ({ name, value, placeholder, onSearch }) => (
  <SearchFieldWithDebounce
    name={t(name)}
    placeholder={t(placeholder)}
    value={value}
    onChange={onSearch}
    onReset={() => onSearch('')}
    wait={300}
  />
);
